import { createRoot } from 'react-dom/client';

import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import PermissionProvider from '../src/shared/permission/PermissionProvider';
import ApiProvider from './services/ApiProvider';

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

const container = document.getElementById('root');
const root = createRoot(container as Element);

root.render(
  <ApiProvider>
  <PermissionProvider>
  <BrowserRouter>
    <App />
  </BrowserRouter></PermissionProvider>
  </ApiProvider>
)